import {createApp} from 'vue'
import {createPinia} from 'pinia'
import '@pointboard/shared/styles'
import {useAuthenticationStore, useDefaultStore} from './stores'
import Notifications from '@kyvg/vue3-notification'
import '@fortawesome/fontawesome-pro/css/all.min.css'
import 'clipboard'
import App from './App.vue'
import router from './router/routes'
import 'bootstrap'
import {setupSentry} from '@shared/integrations/sentry/sentry'
import FloatingVue from 'floating-vue'
import {register} from 'swiper/element/bundle'

const pinia = createPinia()
const app = createApp(App)

register()
setupSentry(app, {router})

app.use(pinia)
app.use(router)
app.use(Notifications)
app.use(FloatingVue)

app.mount('#app')

export const authenticationStore = useAuthenticationStore()
export const defaultStore = useDefaultStore()
export const mainRouter = router
